const NBATeamIDs = [
    {
        city: "Atlanta",
        id: 1610612737,
        name: "Hawks",
        tricode: "ATL",
    },
    {
        city: "Boston",
        id: 1610612738,
        name: "Celtics",
        tricode: "BOS",
    },
    {
        city: "Brooklyn",
        id: 1610612751,
        name: "Nets",
        tricode: "BKN",
    },
    {
        city: "Charlotte",
        id: 1610612766,
        name: "Hornets",
        tricode: "CHA",
    },
    {
        city: "Chicago",
        id: 1610612741,
        name: "Bulls",
        tricode: "CHI",
    },
    {
        city: "Cleveland",
        id: 1610612739,
        name: "Cavaliers",
        tricode: "CLE",
    },
    {
        city: "Dallas",
        id: 1610612742,
        name: "Mavericks",
        tricode: "DAL",
    },
    {
        city: "Denver",
        id: 1610612743,
        name: "Nuggets",
        tricode: "DEN",
    },
    {
        city: "Detroit",
        id: 1610612765,
        name: "Pistons",
        tricode: "DET",
    },
    {
        city: "Golden State",
        id: 1610612744,
        name: "Warriors",
        tricode: "GSW",
    },
    {
        city: "Houston",
        id: 1610612745,
        name: "Rockets",
        tricode: "HOU",
    },
    {
        city: "Indiana",
        id: 1610612754,
        name: "Pacers",
        tricode: "IND",
    },
    {
        city: "Los Angeles",
        id: 1610612746,
        name: "Clippers",
        tricode: "LAC",
    },
    {
        city: "Los Angeles",
        id: 1610612747,
        name: "Lakers",
        tricode: "LAL",
    },
    {
        city: "Memphis",
        id: 1610612763,
        name: "Grizzlies",
        tricode: "MEM",
    },
    {
        city: "Miami",
        id: 1610612748,
        name: "Heat",
        tricode: "MIA",
    },
    {
        city: "Milwaukee",
        id: 1610612749,
        name: "Bucks",
        tricode: "MIL",
    },
    {
        city: "Minnesota",
        id: 1610612750,
        name: "Timberwolves",
        tricode: "MIN",
    },
    {
        city: "New Orleans",
        id: 1610612740,
        name: "Pelicans",
        tricode: "NOP",
    },
    {
        city: "New York",
        id: 1610612752,
        name: "Knicks",
        tricode: "NYK",
    },
    {
        city: "Oklahoma City",
        id: 1610612760,
        name: "Thunder",
        tricode: "OKC",
    },
    {
        city: "Orlando",
        name: "Magic",
        id: 1610612753,
        tricode: "ORL",
    },
    {
        city: "Philadelphia",
        id: 1610612755,
        name: "76ers",
        tricode: "PHI",
    },
    {
        city: "Phoenix",
        id: 1610612756,
        name: "Suns",
        tricode: "PHX",
    },
    {
        city: "Portland",
        id: 1610612757,
        name: "Trail Blazers",
        tricode: "POR",
    },
    {
        city: "Sacramento",
        id: 1610612758,
        name: "Kings",
        tricode: "SAC",
    },
    {
        city: "San Antonio",
        id: 1610612759,
        name: "Spurs",
        tricode: "SAS",
    },
    {
        city: "Toronto",
        id: 1610612761,
        name: "Raptors",
        tricode: "TOR",
    },
    {
        city: "Utah",
        id: 1610612762,
        name: "Jazz",
        tricode: "UTA",
    },
    {
        city: "Washington",
        id: 1610612764,
        name: "Wizards",
        tricode: "WAS",
    }
];

export default NBATeamIDs;
